/** `AREA_MANAGER` → `area manager`, as the header writes role codes. */
export function humanRole(code: string): string {
  return code.replace(/_/g, ' ').toLowerCase()
}

/**
 * The header's one-line role caption. A user can hold several roles at once
 * and every one of them applies, so naming only the first would misstate what
 * they can do: the rest are counted, and {@link allRolesLabel} spells them out.
 */
export function roleCaption(roles: string[] | undefined): string {
  const [head, ...rest] = roles ?? []
  if (head === undefined) return ''
  return rest.length === 0 ? humanRole(head) : `${humanRole(head)} +${rest.length}`
}

/** Every role, for the tooltip and the user menu. */
export function allRolesLabel(roles: string[] | undefined): string {
  return (roles ?? []).map(humanRole).join(', ')
}
